import LoginContainer from "../../components/LoginContainer/LoginContainer";


export default function LoginPage() {
  return (
    <LoginContainer />
  )
}